export function replaceMainSiteLinkHostname(url = "<%= host %>", host) {
  const VITE_MAINSITE_HOST =
    import.meta.env.VITE_MAINSITE_HOST || "https://988lifeline.org";
  const base = host || VITE_MAINSITE_HOST;
  return url.replace("<%= host %>", base);
}

export function serializePreChatSurvey({
  interactionIdKey: interaction_id_key,
  modality,
  zipCode: postal_code,
  thoughtsOfSuicide: thoughts_of_suicide,
  upsetAmount: upset_amount,
  isNative: is_native,
  name,
  age,
  gender,
  gender_unlisted,
  transgender,
  mainConcerns: concern,
  mainConcerns_unlisted: concern_unlisted,
  phoneNumber: contact_details,
  locale,
  recaptchaToken: recaptcha_token,
}) {
  return {
    modality,
    locale,
    postal_code,
    recaptcha_token,
    ...(interaction_id_key && { interaction_id_key }),
    ...(name && { name }),
    ...(age && { age }),
    ...(gender && { gender }),
    ...(gender_unlisted && { gender_unlisted }),
    ...(transgender && { transgender }),
    ...(is_native && { is_native }),
    ...(concern.length > 0 && { concern }),
    ...(concern_unlisted && { concern_unlisted }),
    ...(thoughts_of_suicide && { thoughts_of_suicide }),
    ...(upset_amount && { upset_amount }),
    ...(contact_details && { contact_details }),
  };
}

export function serializePostChatSurvey({
  modality: type_param,
  interactionIdKey: session_identifier,
  locale,
  page_load_timestamp,
  caseID: case_id,
  howAreYouFeeling: feeling,
  helpExtent: helpfulness,
  stopSuicide: crisis_effect,
  counselorConcerned: counselor_concerned,
  counselorUnderstood: counselor_understood,
  plansAfter: counselor_provided_plans,
  likelyToFollowPlans: follow_plans_likelihood,
  whatPreventedPlans: reject_plans_reason,
  raceIdentity: race,
  raceIdentity_unlisted: race_unlisted,
  militaryService: military_service,
}) {
  return {
    type_param,
    locale,
    ...(case_id && { case_id }),
    ...(page_load_timestamp && { page_load_timestamp }),
    ...(session_identifier && { session_identifier }),
    ...(feeling && { feeling }),
    ...(helpfulness && { helpfulness }),
    ...(crisis_effect && { crisis_effect }),
    ...(counselor_concerned && { counselor_concerned }),
    ...(counselor_understood && { counselor_understood }),
    ...(counselor_provided_plans && { counselor_provided_plans }),
    ...(follow_plans_likelihood && { follow_plans_likelihood }),
    ...(reject_plans_reason && { reject_plans_reason }),
    ...(race_unlisted && { race_unlisted }),
    ...(race && { race }),
    ...(military_service && { military_service }),
  };
}

export function getModalityFromHostname(hostname = "") {
  switch (true) {
    case hostname.includes("text.988lifeline.org"):
      return "sms";
    case hostname.includes("chat.988lifeline.org"):
      return "web";
  }
}
